import { api } from '@/config/index.js'
import httpApi from '@/utils/http-api.js'

export default {
  getProfile: () => {
    return httpApi.getDataViaApi({
      url: api.kyc.getProfile
    })
  },
  getKycStatus: () => {
    return httpApi.getDataViaApi({
      url: api.kyc.getKycStatus
    })
  },
  getKtpImage: () => {
    return httpApi.getDataViaApi({
      url: api.kyc.getKtpImage
    })
  },
  insertKyc: (requestBody) => {
    return httpApi.postDataViaApi({
      url: api.kyc.insertKyc,
      body: requestBody
    })
  },
  validateKtpImage: (requestBody) => {
    return httpApi.postDataViaApi({
      url: api.kyc.validateKtpImage,
      body: requestBody
    })
  }
}
